// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface TypesCrossClusterReplicationFromConfig
 */
export interface TypesCrossClusterReplicationFromConfig {
  /**
   *
   * @type {string}
   * @memberof TypesCrossClusterReplicationFromConfig
   */
  upstreamDatabaseId?: string;
  /**
   *
   * @type {string}
   * @memberof TypesCrossClusterReplicationFromConfig
   */
  upstreamDatabaseName?: string;
}

/**
 * Check if a given object implements the TypesCrossClusterReplicationFromConfig interface.
 */
export function instanceOfTypesCrossClusterReplicationFromConfig(
  value: object,
): value is TypesCrossClusterReplicationFromConfig {
  return true;
}

export function TypesCrossClusterReplicationFromConfigFromJSON(
  json: any,
): TypesCrossClusterReplicationFromConfig {
  return TypesCrossClusterReplicationFromConfigFromJSONTyped(json, false);
}

export function TypesCrossClusterReplicationFromConfigFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TypesCrossClusterReplicationFromConfig {
  if (json == null) {
    return json;
  }
  return {
    upstreamDatabaseId:
      json['UpstreamDatabaseId'] == null
        ? undefined
        : json['UpstreamDatabaseId'],
    upstreamDatabaseName:
      json['UpstreamDatabaseName'] == null
        ? undefined
        : json['UpstreamDatabaseName'],
  };
}

export function TypesCrossClusterReplicationFromConfigToJSON(
  json: any,
): TypesCrossClusterReplicationFromConfig {
  return TypesCrossClusterReplicationFromConfigToJSONTyped(json, false);
}

export function TypesCrossClusterReplicationFromConfigToJSONTyped(
  value?: TypesCrossClusterReplicationFromConfig | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    UpstreamDatabaseId: value['upstreamDatabaseId'],
    UpstreamDatabaseName: value['upstreamDatabaseName'],
  };
}
